import React, { Component } from 'react'
import { connect } from 'react-redux'
import { forEach, head, get, map, keys, split, size } from 'lodash'
import { adminTagList, invalidateTagLists } from './actions/admin_tag'
import { Separator } from 'components/layout/Separator'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import {showSuccess, showError} from 'actions/Error'
import { handleSubmitResult } from 'actions/form'
import AdminCommonFormLayout from '../layout/AdminCommonFormLayout'
import { FormikInputField } from 'components/form/InputField'
import AdminTagForm from './form/AdminTagForm'
import { validationSchema } from './form/AdminTagForm'

class AdminTag extends Component {

    componentDidMount() {
        const { dispatch, tag_id } = this.props
        dispatch(adminTagList.ensureObjectLoaded(tag_id))
    }

    componentDidUpdate(prev_props) {
        const { dispatch, tag_id } = this.props
        dispatch(adminTagList.ensureObjectLoaded(tag_id))
    }

    onSave = (values, formik_funcs) => {
        const { history, onSubmit, dispatch, tag_id } = this.props

        const on_ok = function(json) {
            dispatch(invalidateTagLists())
            showSuccess("Saved", "Tag saved")

            if ( ! tag_id ) {
                history.push(`/admin/tag/${json.id}`)
            }
        }
        if ( tag_id ) {
            values.id = tag_id
            return dispatch(adminTagList.saveObject(values)).then((res) => handleSubmitResult({res, formik_funcs, on_ok}))
        } else {
            return dispatch(adminTagList.saveNewObject(values)).then((res) => handleSubmitResult({res, formik_funcs, on_ok}))
        }
    }

    getCellValue = (header_key, item, index) => {
        switch( header_key ) {
            default:
                return undefined
        }
    }

    render() {
        const { initial_values, is_loading, is_busy, tag, tag_id } = this.props
        const that = this
        const title = `${get(tag, "name", 'New tag')}`

        return (
            <AdminCommonFormLayout breadcrumbs={[{name: 'admin_home'},

                                                 {name: 'tags',
                                                  label: 'Tags',
                                                  url: '/admin/tags'},

                                                 {name: 'tag',
                                                  label: get(tag, "name", 'New tag'),
                                                  url: `/admin/tag/${tag_id}`
                                                 }
                                                ]}
                                   is_busy={is_busy}
                                   is_loading={is_loading}
                                   title={title}
                                   initial_values={initial_values}
                                   validationSchema={validationSchema}
                                   onSave={this.onSave}>

              {
                  ({formik_props}) => <AdminTagForm formik_props={formik_props} />
              }
            </AdminCommonFormLayout>
        )
    }

}

function mapStateToProps(state, props) {
    const tag_id = get(props, ["match", "params", "tag_id"], null)
    const tag = adminTagList.getObject(tag_id)

    return {
        tag_id,
        tag,
        is_loading: adminTagList.isLoading() || (tag_id && !get(tag, "id")),
        is_busy: adminTagList.getIsSavingObject(),
        initial_values: tag
    }
}

export default connect(mapStateToProps)(AdminTag)
